import { render, staticRenderFns } from "./ModalCommandArgs.vue?vue&type=template&id=647968e4&scoped=true"
import script from "./ModalCommandArgs.vue?vue&type=script&lang=js"
export * from "./ModalCommandArgs.vue?vue&type=script&lang=js"
import style0 from "./ModalCommandArgs.vue?vue&type=style&index=0&id=647968e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647968e4",
  null
  
)

export default component.exports